export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOGOUT = "LOGOUT";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const QUESTION_TYPE = "QUESTION_TYPE";
export const IS_AZHAR = "IS_AZHAR";
export const MARK_QUIZ = "MARK_QUIZ";
